import MojitoCore from 'mojito/core';
import PriceBoostCouponSkeletonImpl from './price-boost-coupon-skeleton';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that displays skeleton for price boost coupon.
 *
 * @class PriceBoostCouponSkeleton
 * @memberof Mojito.Modules.PriceBoostCoupon
 */

export default UIView('PriceBoostCouponSkeleton', PriceBoostCouponSkeletonImpl);
